var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayoutApp',[_c('div',{staticClass:"help"},[_c('BaseNavSecondary',{attrs:{"paths":['/help/guides', '/help/contact']}}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }